<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.userLogs')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-cogs"></i>
          <span>{{$ml.get('shared.settings')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.userLogs')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row" style="margin-bottom:10px;">
        <div class="col-sm-4">
          <div class="input-group">
            <span class="input-group-addon">{{$ml.get('userLogs.user')}} :</span>
            <select @change="changeUser($event)" class="form-control">
              <option selected value="0">{{$ml.get('general.all')}}</option>
              <option
                v-for="user in userList"
                :key="user.id"
                :value="user.id"
                :selected="selectedUserId == user.id"
              >{{user.name}}</option>
            </select>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="input-group">
            <input type="datetime-local" v-model="startDate" class="form-control" />
            <span class="input-group-addon">-</span>
            <input type="datetime-local" v-model="endDate" class="form-control" />
            <span class="input-group-btn">
              <button
                @click="send()"
                type="button"
                class="btn btn-primary "
                style="width:100%;"
              >
                <i class="fa fa-search"></i> {{$ml.get('general.view')}}
              </button>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-primary">
            <div class="box-header">
              <i class="fa fa-setting"></i>
              <h3 class="box-title">
                <span>{{$ml.get('userLogs.userLogList')}}</span>
              </h3>
              <div class="pull-right">
                <button v-show="logList.length > 0 && authControl == 0" @click="exportToPDF()" type="button" class="btn btn-danger btn-sm ">
                  <i class="fa fa-share"></i> {{$ml.get('general.exportToPdfOrPrint')}}
                </button>
              </div>
            </div>
            <div class="box-body">
              <div
                id="printReport"
                v-show="logList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
              <div align="center">
                  <span>{{$ml.get('userLogs.userLogs')}} ({{this.startDate | toDateFormatGet("gg.aa.yyyy ss:dd")}} - {{this.endDate | toDateFormatGet("gg.aa.yyyy ss:dd")}})</span>
                </div>
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>{{$ml.get('userLogs.userName')}}</th>
                      <th>{{$ml.get('userLogs.logTime')}}</th>
                      <th>{{$ml.get('userLogs.logDescription')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="log in logList" :key="log.id" class="rows">
                      <td>
                        <span>{{log.userName}}</span>
                      </td>
                      <td>
                        <span>{{log.date | toDateFormatGet}}</span>
                      </td>
                      <td>
                        <span>{{log.description}}</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="logList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i> {{$ml.get('userLogs.logNotRecord')}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      selectedUserId: 0,
      startDate: null,
      endDate: null,
      users: [],
      logs: []
    };
  },
  filters: {
    toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl(){
      return this.$store.getters.getAuthAyarlar;
    },
    userList() {
      return this.users;
    },
    logList() {
      return this.logs;
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    exportToPDF() {
      this.$htmlToPaper("printReport");
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      if (this.startDate == null) {
        this.startDate = yil + "-" + ay + "-" + gun + "T00:00";
      }
      if (this.endDate == null) {
        this.endDate = yil + "-" + ay + "-" + gun + "T23:59";
      }
    },
    changeUser(event) {
      this.selectedUserId = event.target.value;
    },
    async send() {
      if ((this.startDate == null) | (this.endDate == null)) {
        alertify.warning(this.$ml.get('alerts.pleaseCheckEnteredValue'));
        return;
      }
      try {
        this.isLoading = true;
        const logs = [];
        let selectedUser = this.selectedUserId;
        var startDate = this.startDate;
        var endDate = this.endDate;
        const response = await this.$axios
          .post("/UserLogs", {
            userId: selectedUser,
            startDate: startDate,
            endDate: endDate
          })
          .then(response => {
            response.data.forEach(doc => {
              logs.push({
                id: doc.id,
                userName: doc.userName,
                date: doc.date,
                description: doc.description
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.logs = logs;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
        this.isLoading = false;
      }
    },
    async getUsers() {
      try {
        this.getDefaultDate();
        const users = [];
        const response = await this.$axios
          .get("/UserLogs/GetUsers")
          .then(response => {
            response.data.forEach(doc => {
              users.push({
                id: doc.id,
                name: doc.name
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get('errors.connectionError'));
                this.isLoadingDetail = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingDetail = false;
                return;
              }
            }
          });
        this.users = users;
      } catch (error) {
        console.error(error);
        alertify.error(error.message);
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(this.$ml.get('alerts.youAreOnlyAuthorizedToViewThisPage'));
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getUsers();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/userLogs/UserLogs.vue